var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning mb-2",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa fa-warning",attrs:{"aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(_vm.$t('TL_EXPORT_FAILURE_WARNING'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }